import './Admin.css';
import CreateITContacts from './content/contacts/CreateITContacts';
import SearchITContacts from './content/contacts/SearchITContacts';
import CreateRequest from './content/requests/CreateRequest';
import SearchRequest from './content/requests/SearchRequest';

export const admin_routes = {
    "requests": {
        name: "requests",
        component: null,
        icon: "fas fa-file-signature",
        subMenu: {
            "search": {
                name: "search",
                icon: "fas fa-filter",
                component: <SearchRequest />
            },
            "add request": {
                name: "add request",
                icon: "fas fa-plus-circle",
                component: <CreateRequest />
            }
        }
    },
    "it-contacts": {
        name: "IT contacts",
        component: null,
        icon: "fas fa-desktop",
        subMenu: {
            "search": {
                name: "search",
                icon: "fas fa-filter",
                component: <SearchITContacts />
            },
            "add request": {
                name: "add request",
                icon: "fas fa-plus-circle",
                component: <CreateITContacts />
            }
        }
    }

}